import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc.js'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore.js'
import { notifications } from '@mantine/notifications'
import type { ReactNode } from 'react'
import type { MantineColor } from '@mantine/core'
import type { ResponseInterface } from '@/interfaces/ResponseInterface'
import type { AxiosRequestConfig, AxiosResponse, AxiosInstance as ax } from 'axios'
import type { WvcHolidayEntity } from '@/interfaces'

dayjs.extend(utc)
dayjs.extend(isSameOrBefore)

export interface AxiosInstance extends ax {
	request: <T = any, R = AxiosResponse<ResponseInterface<T>>>(config: AxiosRequestConfig) => Promise<R>

	get: <T = any, R = AxiosResponse<ResponseInterface<T>>>(url: string, config?: AxiosRequestConfig) => Promise<R>

	delete: <T = any, R = AxiosResponse<ResponseInterface<T>>>(url: string, config?: AxiosRequestConfig) => Promise<R>

	head: <T = any, R = AxiosResponse<ResponseInterface<T>>>(url: string, config?: AxiosRequestConfig) => Promise<R>

	options: <T = any, R = AxiosResponse<ResponseInterface<T>>>(url: string, config?: AxiosRequestConfig) => Promise<R>

	post: <T, R = AxiosResponse<ResponseInterface<T>>>(url: string, data?: any, config?: AxiosRequestConfig) => Promise<R>

	put: <T = any, R = AxiosResponse<ResponseInterface<T>>>(url: string, data?: any, config?: AxiosRequestConfig) => Promise<R>

	patch: <T = any, R = AxiosResponse<ResponseInterface<T>>>(url: string, data?: any, config?: AxiosRequestConfig) => Promise<R>
}

export const isHoliday = (d: Date, holidays: Array<WvcHolidayEntity>) => {
	return (holidays || []).find((h) => d.getDate() === h.date && d.getMonth() + 1 === h.month && (h.everyYear || d.getFullYear() === h.year))
}

export const getYear = () => {
	if (new Date().getMonth() > 8) {
		return new Date().getFullYear() + 1
	}
	return new Date().getFullYear()
}

export function convertDate(rawDate?: Date | string | null, format?: string, inUtc?: boolean) {
	format = format || 'DD MMM, YYYY'
	return rawDate ? (inUtc ? dayjs(rawDate).utc().format(format) : dayjs(rawDate).format(format)) : 'N/A'
}

export function getFile(file: string, fallBack = '/images/no-image.svg'): string {
	return file ? `/resources/${file}` : fallBack
}

export const mobileWidth = '(max-width: 768px)'

export function showNotification({
	data,
	message,
	type,
	caption,
	color,
	timeout,
	closeBtn,
	icon,
	loading,
}: {
	data?: ResponseInterface<any>
	icon?: ReactNode
	message?: ReactNode
	type?: MantineColor
	caption?: ReactNode
	color?: MantineColor
	timeout?: number
	closeBtn?: boolean
	loading?: boolean
}) {
	notifications.show({
		title: message || data?.message,
		message: caption || data?.caption || '',
		color: color || type || (data?.isSuccess ? 'positive' : 'warning'),
		autoClose: timeout || 5000,
		withCloseButton: data?.closeBtn || closeBtn || true,
		icon,
		loading,
	})
}
